import React from 'react';

const METHOD_CLASS = {
  GET: 'bg-sky-600/15 text-sky-700 dark:bg-sky-400/20 dark:text-sky-300',
  POST: 'bg-emerald-600/15 text-emerald-700 dark:bg-emerald-400/20 dark:text-emerald-300',
  PUT: 'bg-amber-600/15 text-amber-700 dark:bg-amber-400/20 dark:text-amber-300',
  DELETE: 'bg-rose-600/15 text-rose-700 dark:bg-rose-400/20 dark:text-rose-300',
  PATCH: 'bg-yellow-500/20 text-yellow-800 dark:bg-yellow-400/20 dark:text-yellow-300',
  OPTIONS: 'bg-violet-600/15 text-violet-700 dark:bg-violet-400/20 dark:text-violet-300',
  HEAD: 'bg-slate-500/20 text-slate-700 dark:bg-slate-400/20 dark:text-slate-200'
};

function HttpMethodBadge({ method }) {
  const resolvedMethod = (method || '').toUpperCase();

  return (
    <span
      className={`inline-flex min-w-14 items-center justify-center rounded-md px-2 py-1 text-[10px] font-bold tracking-wider ${
        METHOD_CLASS[resolvedMethod] || METHOD_CLASS.HEAD
      }`}
    >
      {resolvedMethod}
    </span>
  );
}

export default HttpMethodBadge;
